import { Face } from '@haechi-labs/face-sdk';
import { Wallet } from '@haechi-labs/face-types';
import { bsc, bscTestnet, Chain, goerli, mainnet, polygon, polygonMumbai } from '@wagmi/chains';
import { WalletConnectConnector } from '@wagmi/connectors/walletConnect';

import { FaceWalletConnector } from './connectors/FaceWalletConnector';

type WalletConnectConnectorConfig = ConstructorParameters<typeof WalletConnectConnector>[0];
export type WalletConnectConnectorOptions = WalletConnectConnectorConfig['options'];

type WalletConfig = {
  chains?: Chain[];
};

const defaultChains = [bsc, bscTestnet, goerli, mainnet, polygon, polygonMumbai];

export function getMetaMask(config?: WalletConfig): Wallet {
  return {
    id: 'metaMask',
    name: 'MetaMask',
    iconUrl: 'https://storage.googleapis.com/bkt-t-face-common-asset/metamask.svg',
    downloadUrls: {
      android: 'https://play.google.com/store/apps/details?id=io.metamask',
      ios: 'https://apps.apple.com/us/app/metamask/id1438144202',
      chrome: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
      firefox: 'https://addons.mozilla.org/firefox/addon/ether-metamask',
      edge: 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm',
      opera: 'https://addons.opera.com/extensions/details/metamask-10',
      default: 'https://metamask.io/download',
    },
    createConnector: async () => {
      const { MetaMaskConnector } = await import('@wagmi/connectors/metaMask');
      return new MetaMaskConnector({ chains: config?.chains ?? defaultChains });
    },
  };
}

export function getWalletConnectLegacy(config?: WalletConfig): Wallet {
  return {
    id: 'walletConnectLegacy',
    name: 'WalletConnectLegacy',
    iconUrl: 'https://storage.googleapis.com/bkt-t-face-common-asset/walletconnect.svg',
    createConnector: async () => {
      const { WalletConnectLegacyConnector } = await import(
        '@wagmi/connectors/walletConnectLegacy'
      );
      return new WalletConnectLegacyConnector({
        chains: config?.chains ?? defaultChains,
        options: {
          qrcode: true,
        },
      });
    },
  };
}

export function getWalletConnect(
  config: WalletConfig & { options: WalletConnectConnectorOptions }
): Wallet {
  return {
    id: 'walletConnect',
    name: 'WalletConnect',
    iconUrl: 'https://storage.googleapis.com/bkt-t-face-common-asset/walletconnect.svg',
    createConnector: async () => {
      const { WalletConnectConnector } = await import('@wagmi/connectors/walletConnect');
      return new WalletConnectConnector({
        chains: config?.chains ?? defaultChains,
        options: config.options,
      });
    },
  };
}

export function getFaceWallet(config: WalletConfig & { face: Face }): Wallet {
  return {
    id: 'faceWallet',
    name: 'Face Wallet',
    iconUrl: 'https://storage.googleapis.com/bkt-t-face-common-asset/faceIcon.svg',
    createConnector: async () => {
      return new FaceWalletConnector({ chains: config?.chains, options: { face: config.face } });
    },
  };
}
